import { LayoutGrid, User } from 'lucide-react';

export const DEFAULT_MENU_ICON = User;
export const DEFAULT_MENU_HIGHLIGHT_ICON = LayoutGrid;
export const DEFAULT_MENU_AVATAR = { initials: 'MA' };

export function joinClasses(...parts) {
  return parts.filter(Boolean).join(' ');
}

export function normalizeMenuItemSize(size) {
  return size === 'small' ? 'small' : 'medium';
}

export function normalizeMenuItemState(state, disabled, loading) {
  if (loading) return 'skeleton';
  if (disabled) return 'disabled';
  if (!state || state === 'default') return 'default';
  return state;
}

export function resolveLucideIcon(value, DefaultIcon) {
  if (value === false || value == null) return null;
  if (value === true) return DefaultIcon;
  return value;
}

export function resolveAvatar(value) {
  if (value === false || value == null) return null;
  if (value === true) return DEFAULT_MENU_AVATAR;
  return value;
}

export function normalizeCheckbox(checkbox) {
  if (!checkbox) return null;
  if (checkbox === true) return {};
  return checkbox;
}

/**
 * `aria-selected` of a menu row. An `option` always reports it (true or false)
 * because a listbox has to announce the unselected state too; every other role
 * keeps it only when selected, and never on a checkbox row (`aria-checked`
 * carries that state).
 *
 * @param {{ role: string, hasCheckbox: boolean, isSelected: boolean }} params
 * @returns {boolean | undefined}
 */
export function resolveAriaSelected({ role, hasCheckbox, isSelected }) {
  if (role === 'option') return isSelected;
  if (!hasCheckbox && isSelected) return true;
  return undefined;
}

export const stopPropagation = (event) => {
  event.stopPropagation();
};

export function handleMenuItemKeyDown(onClick, event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  onClick?.(event);
}

export function handleMenuItemCloseClick(onClose, event) {
  event.stopPropagation();
  onClose?.(event);
}
